import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';

export const selectInstitutionsState = (state: AppState) => state.institutions;

export const selectInstitutions = createSelector(selectInstitutionsState, state => state.institutions);
